import type { Rating } from '@/types/rating';
import type { RatingWire } from '../schemas/rating';

/**
 * Convert a menu item rating from wire format to domain format.
 * All fields are primitive passthroughs; a new object is returned.
 */
export function mapRatingWireToDomain(wire: RatingWire): Rating {
  return {
    id: wire.id,
    key: wire.key,
    label: wire.label,
  };
}
